module.exports = __webpack_public_path__ + "media/images/lb/203-60d4f5e7404b144e43ba66876bff748b.svg";